import { createAction } from '@reduxjs/toolkit';
export const threadsUpdated = createAction('viewMembersUpdates/threadsUpdated', payload => ({
  payload
}));
export const viewMemberPatched = createAction('viewMembersUpdates/viewMemberPatched', payload => ({
  payload
}));